export default {
  section_title: 'Tratamento fiscal',
  inherited_from_partner: 'Herdado',
  inherited_from_region: 'Padrão regional',
  reset: 'Repor para herdado',
  form: {
    tax_name: {
      label: 'Nome do imposto',
      tooltip: 'Como o imposto é designado nos recibos e faturas, por exemplo, IVA ou GST.',
    },
    tax_behaviour: {
      label: 'Tratamento fiscal',
      tooltip: 'Se os preços do seu menu já incluem imposto, ou se o imposto é adicionado no checkout.',
      options: {
        inclusive: 'Incluído nos preços do menu',
        exclusive: 'Adicionado no checkout',
      },
    },
    delivery_fee_tax_percentage: {
      label: 'Taxa de imposto da taxa de entrega',
      tooltip: 'A taxa a que a sua própria taxa de entrega é tributada, que pode diferir da taxa sobre a comida.',
    },
  },
  impact: {
    title: 'Alterar o tratamento fiscal dos seus restaurantes?',
    affected_one: '{{count}} restaurante segue o seu padrão e será alterado.',
    affected_other: '{{count}} restaurantes seguem o seu padrão e serão alterados.',
    overriding_one: '{{count}} restaurante tem a sua própria definição e vai mantê-la.',
    overriding_other: '{{count}} restaurantes têm a sua própria definição e vão mantê-la.',
    confirm: 'Alterá-los',
  },
  buttons: {
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  toasts: {
    load_error: 'Falha ao carregar as definições fiscais',
    impact_error: 'Falha ao verificar quais os restaurantes que isto afetaria',
    impact_changed_one: 'O número de restaurantes afetados mudou para {{count}}. Reveja e guarde novamente.',
    impact_changed_other: 'O número de restaurantes afetados mudou para {{count}}. Reveja e guarde novamente.',
    failed_to_save_changes: 'Falha ao guardar as alterações',
    changes_got_saved: 'As alterações foram guardadas',
  },
};
